import { redirect } from "@tanstack/react-router";
import type { AuthInfo } from "../hooks/useAuth";
import type { UserRole } from "../types";

export const requireAuth = async (authInfo: AuthInfo) => {
  if (!authInfo.isAuthenticated) {
    const params = new URLSearchParams(window.location.search);
    const activate = params.get("activate");
    const token = params.get("token");

    let email: string | undefined;
    if (activate && token) {
      try {
        const res = await fetch(`/api/v1/activation/resolve?token=${encodeURIComponent(token)}`);
        if (res.ok) {
          const data = await res.json();
          email = data.email;
        }
      } catch {
        // Token resolution failed — proceed without login_hint
      }
    }

    throw authInfo.loginWithRedirect({
      appState: { returnTo: window.location.pathname + window.location.search },
      authorizationParams: {
        ...(activate && { activate, "ext-activate": activate }),
        ...(email && { login_hint: email }),
      },
    });
  }
};

export const requireUserRole = async (authInfo: AuthInfo, allowedUserRoles: UserRole[]) => {
  await requireAuth(authInfo);

  const hasAccess = authInfo.userRole && allowedUserRoles.includes(authInfo.userRole);
  if (!hasAccess) {
    throw redirect({ to: "/unauthorized" });
  }
};
